import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import CustomBreadcrumb from 'components/base/CustomBreadcrumb';
import CustomListComponent from 'components/base/CustomListComponent';
import { createAction } from 'utils';
import ContentSections from 'components/base/ContentSections';
import { APIStatus } from 'config/CustomEnums';
import Loading from 'components/base/Loading';
import AuthButton from 'components/base/AuthButton';
import { PermissionCodes } from 'config/PermissionCodes';
import MembershipInfoCard from 'components/customer/MembershipInfoCard';

function LanguageDetail({
  language,
  status,
}) {
  const history = useHistory();
  const dispatch = useDispatch();
  const params = useParams();

  const tabs = [
    {
      name: 'Detail',
      content: (
        <ContentSections
          sections={
            status === APIStatus.calling
              ? [<Loading />]
              : [
                  <MembershipInfoCard
                    title="information"
                    data={language}
                    fields={[
                      [{ title: 'Name', field: 'sourceName' }],
                      [{ title: 'Parameter', field: 'parameter' }],
                    ]}
                  />,
                <MembershipInfoCard
                  title="GENERAL"
                  data={language}
                  fields={[
                    [{ title: 'Creation time', field: 'detailDisplayCreationDate' }],
                    [{ title: 'Last modified time', field: 'detailDisplayLastModifiedTime' }],
                    [{ title: 'Last modified by', field: 'displayLastModifiedBy' }],
                  ]}
                />,
                ]
          }
          hidePreview
          // sectionStyle="detail-info-section-item"
        />
      ),
    },
  ];

  const buttons = [
    <AuthButton
      title="Edit"
      action={() => {
        // dispatch({ type: 'customerList/clearData' });
        dispatch({ type: 'language/clearData' });
        history.push({
          pathname: 'edit/',
        });
      }}
      requires={PermissionCodes.changeLanguage}
    />,
  ];

  const [activeTab, setActiveTab] = useState(tabs[0].name);

  useEffect(() => {
    if (params.id) {
      dispatch(
        createAction('language/getOneDetail')({
          id: params.id,
          view: true,
        }),
      );
    }
    return () => {
      dispatch({ type: 'language/clearData' });
    };
  }, [dispatch, params.id]);

  return (
    <div className="campaign-category-detail">
      <CustomListComponent
        caution={{
          detail: '',
          title: language.sourceName,
        }}
        defaultActiveKey={activeTab}
        breadcrumb={<CustomBreadcrumb name={language.sourceName} />}
        buttons={buttons}
        tabs={tabs}
        onTabChange={(key) => {
          setActiveTab(key);
        }}
      />
    </div>
  );
}

const mapPropsToState = (state) => ({
  language: state.language.detail,
  status: state.loading.status,
})

export default connect(mapPropsToState)(LanguageDetail)